import Swiper from 'react-id-swiper';

import './styles.less';

export default Swiper;